<evsb-standard-modal-window [fullHeight]="true">
    <ng-container *ngIf="!isLoading">
      <header>
        <evsb-modal-header
          [backLabel]="'modules.evsb.navigation.back' | translate"
          [backEnabled]="canGoBack"
          (back)="goBack()"
        >
          {{ 'modules.evsb.chargingStation.title' | translate }}
        </evsb-modal-header>
      </header>
    
      <div class="py-10 px-8 md:px-16 overflow-y-auto">
        <h3 class="text-grey text-sm">{{ 'modules.evsb.chargingStation.outboundForm.title' | translate }}</h3>
        <h2 class="text-xl text-grey-dark font-bold">{{ 'modules.evsb.chargingStation.outboundForm.subtitle' | translate }}</h2>
    
        <form class="mt-6" [formGroup]="form" (ngSubmit)="submit()">
          <evsb-text-input
            class="block mb-4"
            formControlName="vatNumber"
            (keyup)="normalizeVatNumber()"
            [error]="invalid('vatNumber') && { error: 'modules.evsb.form.required' | translate }"
            [label]="{ label: 'modules.evsb.form.vatNumber.label' | translate }"
            [placeholder]="'modules.evsb.form.vatNumber.placeholder' | translate"
          ></evsb-text-input>
    
          <evsb-text-input
            class="block mb-4"
            formControlName="company"
            [error]="invalid('company') && { error: 'modules.evsb.form.required' | translate }"
            [label]="{ label: 'modules.evsb.form.company.label' | translate }"
            [placeholder]="'modules.evsb.form.company.placeholder' | translate"
          ></evsb-text-input>
    
          <evsb-text-input
            class="block mb-4"
            formControlName="firstName"
            [error]="invalid('firstName') && { error: 'modules.evsb.form.required' | translate }"
            [label]="{ label: 'modules.evsb.form.firstName.label' | translate }"
            [placeholder]="'modules.evsb.form.firstName.placeholder' | translate"
          ></evsb-text-input>
    
          <evsb-text-input
            class="block mb-4"
            formControlName="lastName"
            [error]="invalid('lastName') && { error: 'modules.evsb.form.required' | translate }"
            [label]="{ label: 'modules.evsb.form.lastName.label' | translate }"
            [placeholder]="'modules.evsb.form.lastName.placeholder' | translate"
          ></evsb-text-input>
    
          <evsb-email
            class="block mb-4"
            formControlName="telephone"
            (keyup)="normalizePhoneNumber()"
            [error]="invalid('telephone') && { error: 'modules.evsb.form.validtelephoneRequired' | translate }"
            [label]="{ label: 'modules.evsb.form.telephone.label' | translate }"
            [placeholder]="'modules.evsb.form.telephone.placeholder' | translate"
          ></evsb-email>
    
          <evsb-email
            class="block mb-4"
            formControlName="email"
            [error]="invalid('email') && { error: 'modules.evsb.form.validEmailRequired' | translate }"
            [label]="{ label: 'modules.evsb.form.email.label' | translate }"
            [placeholder]="'modules.evsb.form.email.placeholder' | translate"
          ></evsb-email>
    
          <app-checkbox-input
            class="block mb-4"
            formControlName="alreadyClient"
            [error]="invalid('alreadyClient') && { error: 'modules.evsb.form.required' | translate }"
            [label]="{ label: 'modules.evsb.form.alreadyClient.label' | translate }"
          ></app-checkbox-input>
    
          <app-checkbox-input
            class="block mb-4"
            formControlName="consent"
            [error]="invalid('consent') && { error: 'modules.evsb.form.required' | translate }"
            [label]="{ label: 'modules.evsb.form.consent.label' | translate }"
          ></app-checkbox-input>
        </form>
      </div>
    
      <footer [@fadeInUp]>
        <evsb-modal-footer>
          <div class="w-full flex flex-col gap-5">
            <evsb-primary-button [fullWidth]="true" (click)="submit()">
              {{ 'modules.evsb.form.submit' | translate }}
            </evsb-primary-button>
          </div>
        </evsb-modal-footer>
      </footer>
    </ng-container>
  
    <div *ngIf="isLoading" class="py-10 px-8 md:px-16">
      <evsb-loading [title]="'modules.evsb.form.status.sending' | translate"></evsb-loading>
    </div>
  </evsb-standard-modal-window>
  